import { addMessage, whatsNextHelp } from './chatUtils';
import chatElements from './chatElements';
import { setCurrentQuestionIndex, setIsResuming, clearUserResponses } from './chatState';
import { askNextQuestion } from './chatUtils';

const { chatBody, chatInput } = chatElements;

// Creates form question array based on flow type
function formQuestions(flowType = '') {
  const baseQuestions = [
    { key: 'name_first', question: "May I have your first name?", validate: validateNotEmpty, errorMessage: "first name" },
    { key: 'name_last', question: "And what's your last name?", if_first: "What's your last name?", validate: validateNotEmpty, errorMessage: "last name" },
    { key: 'email_address', question: "How about your email address?", if_first: "What's your email address?", validate: validateEmail, errorMessage: "email address" },
  ];

  const scheduleQuestions = [
    { key: 'phone', question: "Last but not least, what's a good phone number we can reach you at?", if_first: "What's your phone number?", validate: validatePhone, errorMessage: "phone number" },
  ];

  return flowType === 'schedule'
    ? [...baseQuestions, ...scheduleQuestions]
    : [...baseQuestions];
}

// Checks to see if there's stored data for the user so they don't have to reenter info
function checkAndOfferStoredData(formType, questions) {
    const labelMap = {
        name_first: 'First name',
        name_last: 'Last name',
        email_address: 'Email',
        phone: 'Phone'
    };

    let storedDataKeys = [];
    let formTypeActionText = '';
    if (formType === 'schedule') {
        storedDataKeys = ['name_first', 'name_last', 'email_address', 'phone'];
        formTypeActionText = ' for scheduling the call';
    } else if (formType === 'newsletter') {
        storedDataKeys = ['name_first', 'name_last', 'email_address'];
        formTypeActionText = ' for subscribing to our newsletter';
    }

    const storedData = getStoredUserData(storedDataKeys);
    const matchingFields = storedDataKeys.filter(key => storedData[key]);

    // Shows found data for user
    if (matchingFields.length > 0) {
        let summary = '<ul class="userDataList">' + matchingFields.map(key => {
            const label = labelMap[key] || key;
            return `<li><strong>${label}:</strong> ${storedData[key]}</li>`;
        }).join('\n') + '</ul>';

        addMessage("Great! You previously entered this information:\n\n" + summary, 'bot', 1000);
        addMessage(`Would you like me to use this info${formTypeActionText}?`, 'bot', 1500);

        setTimeout(() => {
            chatInput.disabled = true;
        }, 2000);

        // Asks if user wants to use existing data
        // Supplies Yes/No buttons
        setTimeout(() => {
            const buttonContainer = document.createElement('div');
            buttonContainer.className = 'whats-next-buttons';

            const yesButton = document.createElement('button');
            yesButton.className = 'chat-option-button';
            yesButton.textContent = "Yes, use it.";
            yesButton.addEventListener('click', () => {
                addMessage("Yes, use it.", 'user');

                const startIndex = questions.findIndex(q => !storedData[q.key]);
                setCurrentQuestionIndex(startIndex >= 0 ? startIndex : questions.length);

                // Set resuming mode ON
                setIsResuming(true);

                setTimeout(() => askNextQuestion(formType), 500);
                buttonContainer.remove();
            });

            const noButton = document.createElement('button');
            noButton.className = 'chat-option-button';
            noButton.textContent = "No, ask me again.";
            noButton.addEventListener('click', () => {
                addMessage("No, ask me again.", 'user');
                addMessage("Sure thing! Let's start over.", 'bot');
                clearUserResponses();
                setCurrentQuestionIndex(0);
                setTimeout(() => askNextQuestion(formType), 500);
                buttonContainer.remove();
            });

            buttonContainer.appendChild(yesButton);
            buttonContainer.appendChild(noButton);
            chatBody.appendChild(buttonContainer);
            chatBody.scrollTop = chatBody.scrollHeight;
        }, 2500);

        return true; // it prompted for reuse
    }

    return false; // nothing to reuse
}

// Submits form data to Gravity Forms
async function submitToGravityForm(option) {
    chatInput.disabled = true;
    const scheduleData = JSON.parse(sessionStorage.getItem('scheduleData') || '{}');

    if (!Object.keys(scheduleData).length) {
        console.error("No schedule data found.");
        return;
    }

    const formData = new FormData();
    formData.append('action', 'chatbot_form_submission'); // WordPress AJAX action
    formData.append('nonce', ajax_object.nonce);
    formData.append('form_data', JSON.stringify(scheduleData));
    formData.append('current_flow', option);
    if (sessionStorage.getItem('decisely_chat_thread_id')){
        formData.append('thread_id', sessionStorage.getItem('decisely_chat_thread_id'))
    }

    try {
        const response = await fetch(`${window.location.origin}/wp-admin/admin-ajax.php`, {
            method: 'POST',
            body: formData
        });

        const data = await response.json();

        if (data.success) {
            if (option === 'schedule') {
                addMessage("Thanks! Your details have been submitted. You should receive an email shortly with a link to your benefit advisor's calendar. Don't forget to check your spam folder!", 'bot');
            }
            else if (option === 'newsletter') {
                addMessage("You've successfully subscribed to our \"RX For Business Growth\" newsletter! Expect great content in your inbox.", 'bot');
            }
            chatInput.disabled = true;
            // sessionStorage.removeItem('scheduleData'); //
            whatsNextHelp(option);
        } else {
            console.error("Submission failed:", data);
            addMessage("Oops! Something went wrong. Please try again later.", 'bot');
        }
    } catch (error) {
        console.error("Error submitting form:", error);
        addMessage("Oops! Something went wrong. Please try again later.", 'bot');
    }
}

// Gets available user daya
function getStoredUserData(keys = []) {
    const stored = JSON.parse(sessionStorage.getItem('scheduleData') || '{}');
    const found = {};

    // If no keys are passed, use all keys in the stored object
    if (keys.length === 0) {
        keys = Object.keys(stored);
    }

    keys.forEach(key => {
        if (stored[key] && stored[key].trim() !== '') {
            found[key] = stored[key];
        }
    });
    return found;
}

// Updates database with full transcript
async function updateTranscriptInDB(data) {
    const formData = new FormData();
    formData.append('action', 'store_chatbot_transcript');
    formData.append('nonce', ajax_object.nonce);
    formData.append('session_id', sessionStorage.getItem('chatSessionID'));
    formData.append('transcript', JSON.stringify(data.transcript));
    formData.append('contact_info', JSON.stringify(data.contact_info));
    formData.append('started_schedule', data.started_schedule);
    formData.append('finished_schedule', data.finished_schedule);
    formData.append('started_lead_form', data.started_lead_form);
    formData.append('finished_lead_form', data.finished_lead_form);
    formData.append('started_newsletter', data.started_newsletter);
    formData.append('finished_newsletter', data.finished_newsletter);

    try {
        const response = await fetch(`${window.location.origin}/wp-admin/admin-ajax.php`, {
            method: 'POST',
            body: formData
        });

        const result = await response.json();

        if (!result.success) {
            console.error(result.data?.message || 'Failed to save transcript.');
        }
    } catch (error) {
        console.error(error.message || 'Error submitting form.');
    }
}

// Validation functions for form options
function validateNotEmpty(value) {
    return value.trim().length > 0;
}

function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function validatePhone(phone) {
    const phoneRegex = /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
    return phoneRegex.test(phone);
}

function validateFTE(fte) {
    return /^\d+$/.test(fte) && parseInt(fte, 10) > 0;
}

function validateState(input) {
    const stateAbbreviations = [
        'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
        'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
        'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
        'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
        'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
        'DC'
    ];

    const cleanedInput = input.replace(/\./g, '').toUpperCase();
    return stateAbbreviations.includes(cleanedInput);
}

export {
    submitToGravityForm,
    updateTranscriptInDB,
    formQuestions,
    getStoredUserData,
    checkAndOfferStoredData,
    validateNotEmpty,
    validateEmail,
    validatePhone,
    validateState
};
